import * as React from 'react';

import { Person } from '../gs-core/common';

import { Subject } from '../common/models';
import { PersonTitle } from './PersonTitle';

interface SubjectPanelProps { subject: Subject; }

export const SubjectPanel = ({ subject }: SubjectPanelProps) => {
  const user = subject.user as Person;
  const origFirstName = user.firstNamePreferred && user.firstNamePreferred !== user.firstName ? user.firstName : '';

  return (
    <div className="SubjectPanel">
      <h2 className="subject-name">
        {user.name} {origFirstName && ( '( ' + origFirstName + ' )' )}
        <small> ( {subject.getIdentifier()} )</small>
      </h2>
      <PersonTitle person={user}/>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Subject/SubjectPanel.tsx